'use client';

import { useTranslations } from 'next-intl';

export default function NotFound() {
  const t = useTranslations('common');

  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <h2>{t('notFound.title')}</h2>
      <p>{t('notFound.message')}</p>
    </div>
  );
}
